import React, { useState } from "react";
import EntityHeader from "./common/EntityHeader";
import Card from "react-bootstrap/Card";
import FieldDisplay from "./common/FieldDisplay";
import { getFieldDate, getFieldName } from "../scripts/helperScripts";
import CareModalityModal from "./common/CareModalityModal";
import ClientRateModal from "./common/ClientRateModal";

function CareModalityEntity({
  clientId,
  clientProgram,
  fosterHomePrograms,
  modalities,
  showExpired,
  updateModalities,
  updateRates,
  currentRate,
  ...rest
}) {
  const [isOpen, setIsOpen] = useState(false);

  const hideModal = () => {
    setIsOpen(false);
  };

  const addNew = () => {
    setIsOpen(true);
  };

  const filterModalities = () => {
    return modalities.filter((modality) => {
      let name = clientProgram.ccx_name;

      if (getFieldName(clientProgram["unit.ccx_programtype"]) === "TFC") {
        name = clientProgram.ccx_name.replace(
          ` - ${getFieldName(clientProgram["unit.ccx_program"])}`,
          ""
        );
      }

      return modality.ccx_clientprogramid["@name"].includes(name);
    });
  };

  return (
    <>
      {getFieldName(clientProgram.ccx_company) !== "SAFY of Alabama" ? (
        <>
          {isOpen ? (
            <ClientRateModal
              isOpen={isOpen}
              hideModal={hideModal}
              clientId={clientId}
              clientProgram={clientProgram}
              fosterHomePrograms={fosterHomePrograms}
              modalities={modalities}
              updateModalities={updateModalities}
              updateRates={updateRates}
              currentRate={currentRate}
            ></ClientRateModal>
          ) : null}
        </>
      ) : null}
      {getFieldName(clientProgram.ccx_company) === "SAFY of Alabama" ? (
        <>
          {isOpen ? (
            <CareModalityModal
              isOpen={isOpen}
              hideModal={hideModal}
              clientId={clientId}
              clientProgram={clientProgram}
              fosterHomePrograms={fosterHomePrograms}
              modalities={modalities}
              updateModalities={updateModalities}
            ></CareModalityModal>
          ) : null}
        </>
      ) : null}
      <EntityHeader
        {...rest}
        title="Care Modalities"
        add={addNew}
        clientId={clientId}
        body={filterModalities().map((modality) => (
          <div
            key={modality.ccx_caremodalityid}
            className={
              modality.ccx_enddate !== undefined && !showExpired
                ? "d-none p-2"
                : "d-block p-2"
            }
          >
            <Card className="card-safy">
              <Card.Header
                className="p-0 ps-2 bg-safy1-1"
                style={{ color: "white" }}
              >
                <div className="row">
                  <div className="col-10 ps-4 pt-1">
                    {getFieldName(modality.ccx_caremodality)}
                  </div>
                  <div className="col-2"></div>
                </div>
              </Card.Header>
              <Card.Body
                className={
                  modality.ccx_enddate === undefined
                    ? "p-2 card-body-safy"
                    : "p-2 bg-warning"
                }
              >
                <div>
                  <strong>{getFieldName(modality.ccx_clientprogramid)}</strong>
                </div>
                <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-2">
                  <div className="col-5">
                    <FieldDisplay
                      label="Start Date: "
                      value={getFieldDate(modality.ccx_startdate)}
                    />
                  </div>
                  <div className="col-2"></div>
                  <div className="col-5">
                    {modality.ccx_enddate && (
                      <FieldDisplay
                        label="Exp Date: "
                        value={getFieldDate(modality.ccx_enddate)}
                      />
                    )}
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
        ))}
      />
    </>
  );
}

export default CareModalityEntity;
